<template>
    <div>
        <div class="row">
            <div class="d-none d-lg-block col-lg-2"></div>
            <div class="col-12 col-lg-8">
                <h1 class="h1">Standards Update</h1>

                <div class="input-group mb-3">
                    <span class="input-group-text" id="basic-addon1"><i class="fas fa-search"></i></span>
                    <input v-model="searchString" type="search" class="form-control bg-white" placeholder="Standards search" @keyup="search" aria-label="Standards search" aria-describedby="basica-addon1"/>
                </div>

                <div>
                    <h3 class="h3">Standards</h3>
                    <div>Click on standard to update</div>
                    <div class="list-group">
                        <div v-for="(st, idx) in standards" class="list-group-item" >
                            <div v-if="editing == st.id">
                                <admin-standard-edit-form 
                                    :value="st"
                                    :areas="areas"
                                    :key="`standard-${st.id}`"
                                    @input="updated(idx, $event)"
                                    @delete="deleted(idx, $event)"
                                ></admin-standard-edit-form>
                            </div>

                            <div v-else @click="editing = st.id" class="pe-pointer">
                                <div class="d-flex align-items-center">
                                    <h5 class="h5 text-primary flex-grow-1">
                                        <span class="text-secondary">
                                            {{ st.code }}<span v-if="st.subcode"></span>&nbsp;{{ st.subcode }}
                                        </span> 
                                        {{ st.strand }}
                                    </h5>
                                    <span class="badge bg-secondary">{{ st.grade_level }}</span>
                                </div>
                                <div class="">
                                    <div>{{ st.content }}</div>
                                    <div v-if="st.notes" class="mt-2 input-group">
                                        <span class="input-group-text" id="notes-label"><i class="far fa-comment-alt text-muted"></i></span>
                                        <div class="form-control">
                                            {{ st.notes }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div v-if="editing == -2" class="list-group-item">
                            <admin-standard-edit-form 
                                :areas="areas"
                                :key="'standard-new'"
                                @input="created($event)"
                            ></admin-standard-edit-form>
                        </div>


                    </div>
                </div>

                <div class="mt-4">
                    <div class="d-flex">
                        <div class="flex-grow-1">
                            <home-button></home-button>
                        </div>
                        <div>
                            <button class="btn btn-primary" @click="create()"><i class="far fa-file-alt me-2"></i>New Standard</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

import AdminStandardEditForm from './AdminStandardEditForm.vue';
import HomeButton from './HomeButton.vue';

export default {
    components: { AdminStandardEditForm, HomeButton },

    mounted() {
        this.isLoading = true;
        axios
            .get('/api/areas')
            .then((response) => {
                this.areas = response.data;
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                this.isLoading = false;
            });
    },

    updated() {
        console.log(this);
    },

    methods: {
        search: function() {
            clearTimeout(this.changeTimeout);

            this.changeTimeout = setTimeout(() => {
                this.isLoading = true;
                axios
                    .get(`/api/admin/standards/${this.searchString}?limit=25`)
                    .then((response) => {
                        this.standards = response.data;
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            }, 1000);
        },

        create: function() {
            console.log('CREATE');
            this.editing = -2;
        },

        created: function() {
            this.editing = -1;
        },

        updated: function(index, event) {
            this.standards[index] = event;
            this.editing = -1;
        },

        deleted: function(index, event) {
            this.standards.splice(index, 1);
        },
    },

    data() {
        return {
            standards: [],
            searchString: '',
            areas: [],
            editing: -1,
        }
    }



}
</script>